import { Brand } from './brand';

export type WorkspaceMode = 'legacy' | 'drive';

export interface WorkspaceDTO {
  companyId: string;
  id?: string;
  name: string;
  projectIds?: string[];
  // Not serialized anymore (RBAC migration) — always undefined from the backend. Kept optional
  // only for the guarded degrade sites; fetch GET /api/workspace/{companyId}/{workspaceId}/users
  // when membership is needed.
  usernames?: string[];
  coverUrl?: string;
  avatarUrl?: string;
  defaultWorkspace?: boolean;
  mode?: WorkspaceMode;
}

export interface Workspace {
  updatedAt: number;
  companyId: string;
  id: string;
  name: string;
  avatarUrl: string | null;
  coverUrl: string | null;
  defaultWorkspace: boolean;
  projectIds: string[];
  // Not serialized anymore (RBAC migration) — see WorkspaceDTO.usernames.
  usernames?: string[];
  numberOfDriveCampaign: number | null;
  numberOfCampaign: number | null;
  numberOfStandaloneProjects: number | null;
  brand: Brand | null;
  createdBy: string;
  storagePath: string;
  avatarUrlOriginal: string | null;
  coverUrlOriginal: string | null;
  mode?: WorkspaceMode;
}

export const WorkspaceUpdatedEvent = 'workspace.updated';
export const WorkspaceAvatarUpdatedEvent = 'workspace.avatarUpdated';
export const WorkspaceCoverUpdatedEvent = 'workspace.coverUpdated';
export const ProjectWorkspaceUpdatedEvent = 'workspace.projectWorkspaceUpdated';
export const ActiveWorkspaceUpdatedEvent = 'activeWorkspace.updated';
export const CachedWorkspacesUpdatedEvent = 'workspace.cachedWorkspacesUpdated';
export const CachedWorkspaceProjectsUpdatedEvent = 'workspace.cachedProjectsUpdated';
export const ComapanyCoverUpdatedEvent = 'company.coverUpdated';
export const WorkspaceDeleted = 'workspace.deleted';
export const WorkspaceOnSaveEvent = 'workspace.onSave';
